export default "__VITE_ASSET__DHKY_Fbg__"